import { http, tryHttp } from '@/axios/instance/http';

export const apiCreateLinkToken = () => tryHttp(http.post<{ link_token: string }>(`merge/create_link_token`));
